export const ORDER_FEATURE = 'order';
export const ORDER_CORE_FEATURE = 'orderCore';